import { render, staticRenderFns } from "./SignaturesList.vue?vue&type=template&id=4ec9d9d3&"
import script from "./SignaturesList.vue?vue&type=script&lang=ts&"
export * from "./SignaturesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports